export default __webpack_public_path__ + "static/media/AdobeStock_315070495.2f8c2fb1.jpg";